import { AxiosInstance } from 'axios';
import * as FileSaver from 'file-saver';

import { IAllFilters } from 'src/views/Links/types';
import createQuery from './utils/createQuery';

export default (api: AxiosInstance, url: string) => async (
  options: IAllFilters
) => {
  const response = await api.post(url, createQuery(options), {
    responseType: 'blob',
  });
  const header = response.headers['content-disposition'];
  const filename = header.split('filename=')[1];
  FileSaver.saveAs(response.data, filename);
};



// WEBPACK FOOTER //
// ./src/services/api/links/export.ts